// extracted by mini-css-extract-plugin
export default {"GalleryMain":"GalleryMain_GalleryMain__a68H0","uploadLinkDiv":"GalleryMain_uploadLinkDiv__i+4A9","cta":"GalleryMain_cta__98TD5","icon":"GalleryMain_icon__Wll1K"};